module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-32.9b78993e.svg";